import { combineReducers } from "redux";
import {
  DfdReducer,
  AuthentificationReducer,
} from "../../modules/dfd/state/DfdReducer";

const rootReducer = combineReducers({
  dfdReducer: DfdReducer,
  authentificationReducer: AuthentificationReducer,
});

export default rootReducer;
